export default "__VITE_ASSET__D0UwLYIr__"